export default "__VITE_ASSET__659f7b96__"